import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@givebutter/primitives/toast';
import { toggleAcknowledgeTransaction } from 'api/transactions';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { transactionQueryKeys } from 'queries/transaction-query-keys';
import { PolymorphicTransaction } from 'types/domain';

const useToggleAcknowledge = (
    options: UseMutationOptions<PolymorphicTransaction, unknown, PolymorphicTransaction, any> = {},
) => {
    const { onSuccess, onError } = options;
    const toast = useToast();
    const queryClient = useQueryClient();
    const { accountId } = useCurrentAccount();

    return useMutation({
        mutationFn: (transaction: PolymorphicTransaction) =>
            toggleAcknowledgeTransaction(transaction.id, !transaction.acknowledged_at),

        onSuccess: (...args) => {
            const [data] = args;
            toast.success(
                `Transaction ${data.acknowledged_at ? 'acknowledged' : 'unacknowledged'}`,
            );
            queryClient.invalidateQueries({
                queryKey: transactionQueryKeys.transactions(accountId),
            });
            onSuccess?.(...args);
        },
        onError: (...args) => {
            toast.error('Unable to update transaction');
            onError?.(...args);
        },
    });
};

export { useToggleAcknowledge };
